

<template src="./Alert.html">
</template>

<script>

import { mapActions } from "vuex";

export default {
    name: 'Alert',
    props: {
        message: {
            required: true,
            type: String,
        },
        type: {
            required: true,
            type: String,
        }
    },
    data() {
        return{
            alert: true,
            timer: 100,
        }
    },
    created() {
        setTimeout(() => {
            this.alert = false;
            this.removeAlert();
        }, 5000);

        setInterval(() => {
            if (this.alert)
                this.timer--;
        }, 40);

    },
    methods: {

        ...mapActions({
            deleteAlert: 'deleteAlert',
        }),

        removeAlert: function(){
            this.deleteAlert({message: this.message, type: this.type});
        },
    }
}
</script>

<style lang="scss" src="./Alert.scss"> </style>